import React, { useMemo } from 'react';
import { ConnectionSelect } from '@kineticdata/react';
import {
  Status,
  SuggestionsContainer,
  generateInput,
  generateSingleSelectionsContainer,
  generateSingleSelection,
} from './TypeaheadDefaults';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';
import { parseRenderOptions } from './utils';
import { getConnectionMetadata } from '@kineticdata/react';

const selectionToValue = selection =>
  `${selection.get('name')} <${
    getConnectionMetadata(selection)?.optionDetail
  }>`;

const Suggestion = ({ suggestion, active }) => (
  <div className={classNames('suggestion', { active })}>
    <div className="large">{suggestion.get('name')}</div>
    <div className="small">
      {getConnectionMetadata(suggestion)?.optionDetail}
    </div>
  </div>
);

export const ConnectionField = props => {
  const renderOptions = parseRenderOptions(props);
  const components = useMemo(
    () => ({
      Input: generateInput({
        size: renderOptions.size,
        className: renderOptions.fieldClassName,
      }),
      Selection: generateSingleSelection(selectionToValue, {
        size: renderOptions.size,
      }),
      SelectionsContainer: generateSingleSelectionsContainer({
        size: renderOptions.size,
      }),
    }),
    [renderOptions.size, renderOptions.fieldClassName],
  );

  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <ConnectionSelect
        components={{ Status, SuggestionsContainer, Suggestion, ...components }}
        disabled={!props.enabled}
        minSearchLength={0}
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        placeholder={renderOptions.placeholder}
        search={props.search}
        form={props.form}
      />
    </FieldWrapper>
  );
};
